import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { FilePreviewer } from 'ng2-file-preview';
import {
  Receipt
} from '../../model/receipt';

export type Images = {
  file: string;
  preview: string[];
  selected?: boolean;
};


@Component({
  selector: 'preview',
  template: require('./preview.component.html'),
  styles: [require('./preview.component.css')]
})
export class PreviewComponent implements OnInit {
  @Input() public model: Images[];
  @Input() public usedImages: Images[];
  public previewImages : Images[] = [];
  public filter : string;
  public showAllImages = false;

  constructor (private ReceiptResource : Receipt) {}

  public ngOnInit () {
    this.loadImages();
  }

  private loadImages() {
    this.ReceiptResource.imageList()
        .$observable
        .subscribe((list : { images : string[] }) => {
          let indexed = {},
              images  = list.images;
          images.forEach((image : string) => {

            if (image.indexOf('preview.png')) {
              const name    = image.replace(/_\d+\.preview\.png/, '');
              indexed[name] = [];
            } else {
              indexed[image] = '';
            }
          });
          images.forEach((image : string) => {
            if (image.indexOf('preview.png') > -1) {
              const name = image.replace(/_\d+\.preview\.png/, '');
              indexed[name].push(image);
            } else if (['png', 'jpg', 'gif'].indexOf(image.substr(image.length - 3)) > -1){
              indexed[image].push(image);
            }
          });

          for (let index of Object.keys(indexed)) {
            this.previewImages.push({
              file: index,
              preview: indexed[index]
            });
          }
        });
  }

  public select(image: Images) {
    if (!image.selected) {
      this.previewImages.forEach((image : Images) => {
        image.selected = false;
      });
      image.selected = true;
    } else {
      if (this.model.indexOf(image) < 0) {
        this.model.push(image);
      }
    }
  }

  public remove(image: Images) {
    this.model.splice(this.model.indexOf(image), 1);
  }

  public filterUsed(image : Images) : boolean {
    if (this.showAllImages) {
      return false;
    }
    for (let i of this.usedImages) {
      for (let j in i) {
        if (image.file === i[j].file) {
          return true;
        }
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/admin/preview/preview.component.ts